<template>
	<div>
		<vxe-modal v-model="modal_model" :title="modal_title" :width="modal_width" :height="modal_height" @show="modal_onshow" show-footer @hide="modal_onhide"
			destroy-on-close>
			<template #default>
				<vxe-grid v-if="list_gridOptions" v-bind="list_gridOptions" @toolbar-button-click="list_toolbarButtonClickEvent"></vxe-grid>
			</template>
			<template #footer>
				<vxe-button status="" content="返回" @click="modal_cancel"></vxe-button>
			</template>
		</vxe-modal>
	</div>
</template>
<style scoped>

</style>
<script>
	import listMixins from '@_system/components/base/mixins/list/list.js'
	import modalMixins from '@_system/components/base/mixins/modal/modal.js'
	export default {
		mixins: [listMixins,modalMixins],
		props: {
			data: {
				default: () => {
					return []
				}
			},
		},
		data() {
			return {
				modal_model:false,
				modal_title: '明细',
				modal_width:1000,
				modal_height:600,
				list_formConfig: [{
						field: 'a',
						title: 'A',
						itemRender: {
							name: '$input'
						}
					}
				],
				list_columns: [
					{
						type: 'seq',
						title: '#',
						width:50,
					},
					{
						field: 'FDate',
						title: '日期',
					},
					{
						field: 'FStockDeptId',
						title: '库存部门',
						sortable:true,
					},
					{
						field: 'FRetcustId',
						title: '退货客户',
						sortable:true,
					},
					{
						field: 'FStockID',
						title: '仓库',
						sortable:true,
					},
					{
						field: 'FTaxPrice',
						title: '含税单价',
					},										
					{
						field: 'F_SXTN_CB',
						title: '成本价(自定义)',
					},
					{
						field: 'F_SXTN_XTAmount',
						title: '系统金额'
					},
					{
						field: 'status',
						title: '状态',
						sortable:true,
						width:100,
						fixed:"right",
						slots: {
							default: ({row}) => {
								if(row.status == 1){
									return '已同步'
								}else{
									return '未同步'
								}
							}
						},
						visible:true
					},	
					{
						field: 'ordercode',
						title: '单据编码',
						width:100,
						fixed:"right",	
						visible:true
					},	
					{
						field: 'error',
						title: '错误',
						width:100,
						fixed:"right",	
						visible:true
					},	
					// {
					// 	title: '操作',
					// 	fixed: "right",
					// 	align: 'center',
					// 	width: 65,
					// 	slots: {
					// 		default: ({row}) => {
					// 			return [<el-button type = "text" size = "mini" onClick = {() => {this.ddcode(row)}}>凭证</el-button>]
					// 		}
					// 	}
					// }					
				],
				list_footerField:[
					{field:'FTaxPrice',toFixed:2},
					{field:'F_SXTN_CB',toFixed:2},
					{field:'F_SXTN_XTAmount',toFixed:2},
					
				]
			}
		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {
			
		},
		methods: {
			list_beforeCreateGrid(gridOptions){
				gridOptions.formConfig = false
				// gridOptions.toolbarConfig.buttons = []
			},
			list() {
				return new Promise(resolve => {
					this.$api.pushdata.listdetail({id:this.data.id}).then((res)=>{
						let	list = res.map((item)=>{
							let data = item.data
							let FEntity = item.data.FEntity[0]
							return {
								FDate:data.FDate,
								FStockDeptId:data.FStockDeptId.FNumber,
								FRetcustId:data.FRetcustId.FNumber,
								FStockID:FEntity.FStockID.FNumber,
								FTaxPrice:FEntity.FTaxPrice,
								F_SXTN_CB:FEntity.F_SXTN_CB,
								F_SXTN_XTAmount:FEntity.F_SXTN_XTAmount,
								status:item.status,
								error:item.error,
							}
						})
						resolve({list:list})
					},()=>{
						this.loading = false
					})
				})
			},
			submit() {
				//this.init()
			},
			reset() {
				//this.init()
			}
		},
		components: {
			
		}
	}
</script>